export default __webpack_public_path__ + "static/media/94447DF3-00.9d01fe7d.png";